import { Store } from "../../../flux/Store";
import { names } from "./LabelActions";

export interface LabelStoreState
{
    label: string;
}

export class LabelStore extends Store<LabelStoreState>
{
    constructor()
    {
        super();
        this.state = { label: null };

        this.register<string>(names.SET, e => {
            if(e.meta === this.dispatchToken)
                return this.field({ label: e.payload });
        });
    }

    getLabel = () => this.state.label;
}


// WEBPACK FOOTER //
// ./src/app/flux/Label/LabelStore.ts